import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { GlobalAudioService } from '@/services/audio/GlobalAudioService';

/**
 * Global Navigation Cleanup Hook
 * Cancels pending audio operations before navigation to prevent errors
 */
export const useAudioNavigationCleanup = () => {
  const location = useLocation();

  useEffect(() => {
    // Cleanup function runs BEFORE navigation
    return () => {
      console.log('🧹 Cleaning up audio before navigation');
      
      // Cancel any pending audio operations
      GlobalAudioService.cancelPendingOperations();
      
      // Don't stop audio, just cancel loading
      const audioState = GlobalAudioService.getState();
      if (audioState.isStopped) {
        GlobalAudioService.cleanup();
      }
    };
  }, [location.pathname]); // Runs on route change
};
